import { Card } from "primereact/card";
import "../account-manager.scss";
import PermissionGate from "~/components/PermissionGate";
import CustomeButton from "~/components/Button";
import AccountManagerInfoForm from "./AccountManagerInfoForm";
import { useCallback, useRef, useState } from "react";
import {
  AccountManagerFormHandle,
  OutletContext,
} from "~/Pages/Tenants/types/tenants";
import ToastMessage from "~/components/ToastMessage";
import { useOutletContext } from "react-router-dom";
import AuditSidebar from "~/components/audit-sidebar/AuditSidebar";
import API_ROUTES_V2 from "~/api-routes-v2";

const AccountManagerInfo = () => {
  const formRef = useRef<AccountManagerFormHandle>(null);
  const {
    handleSave,
    accountManagerInfo,
    toastRef,
    isEditing,
    setIsEditing,
    isLoading,
    managerId,
  } = useOutletContext<OutletContext>();

  const [isDirty, setIsDirty] = useState(false);
  const [isValidForm, setIsValidForm] = useState(false);
  const [isAuditSidebarVisible, setIsAuditSidebarVisible] = useState(false);

  const auditLabels = () => {
    return {
      create: "Account Manager Created",
      update: "Information Updated",
    };
  };

  const editHandler = () => {
    setIsEditing(true);
  };
  const handleSaveClick = useCallback(() => {
    formRef.current?.submit();
  }, []);

  const discardHandler = useCallback(() => {
    formRef.current?.reset();
    setIsEditing(false);
  }, []);

  const handleErrorsChange = useCallback((valid: boolean) => {
    setIsValidForm(valid);
  }, []);

  return (
    <>
      {isAuditSidebarVisible && (
        <AuditSidebar
          heading="Personal Information"
          endpoint={API_ROUTES_V2.FETCH_ACCOUNT_MANAGER_AUDIT}
          id={managerId}
          labels={auditLabels}
          setSidebarToggle={setIsAuditSidebarVisible}
          sidebarToggle={isAuditSidebarVisible}
        />
      )}
      <Card className="account-manager-info-card">
        {/* Header */}
        <div className="header flex justify-content-between">
          <div className="flex flex-column gap-2">
            <p className="title m-0"> Personal Information </p>
            <p className="description m-0">
              Find all personal information related to this admin.
            </p>
          </div>
          <PermissionGate resource="usermanagement" action="modify_any">
            <div className="flex gap-2">
              {isEditing ? (
                <div className="flex gap-2">
                  <CustomeButton
                    label="Discard"
                    variant="outlined"
                    className="discard-button"
                    onClick={discardHandler}
                  />
                  <CustomeButton
                    label="Save Changes"
                    variant="contained"
                    className={"save-changes-btn"}
                    onClick={handleSaveClick}
                    disabled={!isDirty || !isValidForm || isLoading}
                    loading={isLoading}
                  />
                </div>
              ) : (
                <div className="flex gap-2">
                  <CustomeButton
                    label="View History"
                    icon="pi pi-history"
                    iconPos="right"
                    variant="outlined"
                    className="edit-btn"
                    onClick={() => setIsAuditSidebarVisible(true)}
                  />
                  <CustomeButton
                    label="Edit"
                    icon="pi pi-pencil"
                    iconPos="right"
                    variant="contained"
                    className="edit-btn"
                    onClick={editHandler}
                  />
                </div>
              )}
            </div>
          </PermissionGate>
        </div>

        {/* Form */}
        <AccountManagerInfoForm
          accountManagerInfo={accountManagerInfo}
          ref={formRef}
          onSave={handleSave}
          onIsDirtyChange={setIsDirty}
          onErrorsChange={handleErrorsChange}
          isEditing={isEditing}
        />

        {/* toast */}
        <ToastMessage ref={toastRef} />
      </Card>
    </>
  );
};

export default AccountManagerInfo;
